module.exports = "/_next/static/images/19c505abe873e98d2c902ef7f0631bac-mulher-perfil-segurando-cartao-md@2x.jpg";